import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M11 21.66H1a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m9.51-15.23L14.86.78a1.49 1.49 0 0 0-2.12 0L5 8.54A1 1 0 0 0 5 10l6.36 6.37a1 1 0 0 0 1.41 0l7.76-7.76a1.5 1.5 0 0 0-.02-2.18M1.8 19.11a1.75 1.75 0 0 0 1.2.55h4.66a1.84 1.84 0 0 0 1.22-.53l1-1.13a.5.5 0 0 0 0-.69L4.1 11.59a.52.52 0 0 0-.71 0l-2.65 2.7a2.59 2.59 0 0 0 0 3.6Zm14.7 2.55h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2m6.5 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2"
    }, null, -1)
  ]));
}
const interfaceEditToolEraser = { render };
export {
  interfaceEditToolEraser as default,
  render
};
//# sourceMappingURL=interface-edit-tool-eraser.svg.js.map
